@if (data()) {
<section class="question-card" [id]="'block-' + data().id">
  @if (data()?.header?.length > 0) {
    <h2 class="question-card__header">
      {{ data()?.header }}
    </h2>
  }
  <div class="question-card__body">
    @if (inputFormControl()) {
      <form>
        <div class="options-list">
          @for (smartCheckbox of data().options; track smartCheckbox; let i = $index) {
            <div class="option-item">
              <label
                class="option-label"
                [class.disabled]="isInputDisabled()"
                [attr.for]="data().id + smartCheckbox.position.toString() + i"
                >
                @if (!isInputDisabled()) {
                  <input
                (change)="
                  onSelectionChanged($event, data().id, smartCheckbox.position)
                "
                    [id]="data().id + smartCheckbox.position.toString() + i"
                    type="checkbox"
                    [value]="smartCheckbox.value"
                    [attr.name]="data().id + smartCheckbox.position.toString()"
                    />
                }
                @if (isInputDisabled()) {
                  <input
                    [checked]="isSelectionChecked(smartCheckbox.position, data().value)"
                    [id]="data().id + smartCheckbox.position.toString() + i"
                    type="checkbox"
                    [disabled]="isInputDisabled()"
                    [value]="smartCheckbox.value"
                    [attr.name]="data().id + smartCheckbox.position.toString()"
                    />
                }
                <span>{{ smartCheckbox.label }}</span>
              </label>
              @if (showCheckboxAnswers() || isInputDisabled()) {
                @if (smartCheckbox?.correct_selection === true) {
                  <p class="smart-answer smart-answer--correct">
                    <i class="ft-check" aria-hidden="true"></i>
                    <b>{{ correctAnswerLabel() }}</b>
                  </p>
                }
                @if (smartCheckbox?.correct_selection === false) {
                  <p class="smart-answer smart-answer--incorrect">
                    <i class="ft-x" aria-hidden="true"></i>
                    {{ incorrectAnswerLabel() }}
                  </p>
                }
              }
            </div>
          }
          <button
            class="smart-view-answers"
            type="button"
            [disabled]="showCheckboxAnswers() === true"
            (click)="viewCheckBoxAnswers()"
            >
            {{ viewAnswersLabel() }}
          </button>
        </div>
      </form>
    }
  </div>
</section>
}
